import { track } from '@eventbrite/datalayer-library';
import isUndefined from 'lodash/isUndefined';

import { ISocialLogInApiResponseProps } from '../api/social';

import {
    HEAP_EVENT_NAME_SIGNUP_SUCCESSFUL,
    HEAP_EVENT_NAME_WEB_SIGNIN_LOGIN_SUCCESSFUL,
    LOGIN_METHOD_APPLE,
    LOGIN_METHOD_EVENTBRITE,
    LOGIN_METHOD_FACEBOOK,
    LOGIN_METHOD_GOOGLE,
    SIGNUP_TYPE_SIGNUP_PAGE,
} from '../constants/analytics';

import { capitalize } from './utils';

export const trackLoginAndSignUpSuccessInHeap = ({
    loginMethod,
    signupType,
}: {
    loginMethod?: string;
    signupType?: string;
}) => {
    let signupMethod = loginMethod || 'Email';
    signupMethod = signupMethod === 'Eventbrite' ? 'Email' : signupMethod;

    track({
        eventName: HEAP_EVENT_NAME_SIGNUP_SUCCESSFUL,
        eventData: {
            signupMethod,
            signupType,
        },
    });

    track({
        eventName: HEAP_EVENT_NAME_WEB_SIGNIN_LOGIN_SUCCESSFUL,
        eventData: {
            loginMethod: !isUndefined(loginMethod)
                ? capitalize(loginMethod)
                : LOGIN_METHOD_EVENTBRITE,
            isSignUp: true,
        },
    });
};

export const trackLoginSuccessInHeap = ({
    loginMethod,
}: {
    loginMethod?: string;
}) => {
    track({
        eventName: HEAP_EVENT_NAME_WEB_SIGNIN_LOGIN_SUCCESSFUL,
        eventData: {
            loginMethod: !isUndefined(loginMethod)
                ? capitalize(loginMethod)
                : LOGIN_METHOD_EVENTBRITE,
        },
    });
};

export const trackFBLoginSuccessInHeap = ({
    response,
}: {
    response: ISocialLogInApiResponseProps;
}) => {
    if (response.newUser) {
        trackLoginAndSignUpSuccessInHeap({
            loginMethod: LOGIN_METHOD_FACEBOOK,
            signupType: SIGNUP_TYPE_SIGNUP_PAGE,
        });
    } else {
        // One step login
    }
};

export const trackAppleLoginSuccessInHeap = ({
    response,
}: {
    response: any;
}) => {
    if (response.newUser ?? response['new_user']) {
        trackLoginAndSignUpSuccessInHeap({
            loginMethod: LOGIN_METHOD_APPLE,
            signupType: SIGNUP_TYPE_SIGNUP_PAGE,
        });
    } else {
        // One step login
    }
};

export const trackGoogleLoginSuccess = ({ response }: { response: any }) => {
    if (response['new_user']) {
        trackLoginAndSignUpSuccessInHeap({
            loginMethod: LOGIN_METHOD_GOOGLE,
            signupType: SIGNUP_TYPE_SIGNUP_PAGE,
        });
    } else {
        // One step login
    }
};
